const updates = [
  {
    date: '2026.07.30',
    title: '播放线路全面升级',
    desc: '新增3条高清视频播放专线，全国多节点覆盖，加载速度提升40%，观影体验更流畅。',
  },
  {
    date: '2026.07.25',
    title: '暑期档专题上线',
    desc: '精选100部暑期热门大片和剧集，每日更新高清资源，陪你度过精彩暑假。',
  },
  {
    date: '2026.07.18',
    title: '移动端界面优化',
    desc: '全新响应式布局适配更多手机型号，触控操作更灵敏，移动观影体验大幅提升。',
  },
  {
    date: '2026.07.10',
    title: '片库突破20000部',
    desc: '高清电影免费看资源正式突破20000部大关，免费电视剧全集持续扩充中。',
  },
  {
    date: '2026.07.02',
    title: '智能推荐系统上线',
    desc: '基于观影偏好的智能推荐算法，帮你发现更多符合口味的高清影视内容。',
  },
  {
    date: '2026.06.20',
    title: '1080P蓝光专区开放',
    desc: '精选500部蓝光画质影片专区正式开放，高清在线影院体验再升级。',
  },
  {
    date: '2026.06.08',
    title: '全站HTTPS加密',
    desc: '全面启用HTTPS安全加密传输，保护您的观影隐私，营造更安全的高清视频播放环境。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            6080影院的每一次进步，都与你有关
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-[11px] md:left-[13px] top-0 bottom-0 w-0.5 bg-background-300"></div>

            <div className="space-y-8">
              {updates.map((item, idx) => (
                <div key={idx} className="relative">
                  <div className={`absolute -left-[34px] md:-left-[37px] top-1 w-3 h-3 rounded-full border-2 ${
                    idx === 0
                      ? 'bg-primary-500 border-primary-500'
                      : 'bg-background-100 border-background-300'
                  }`}></div>
                  <div className="p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60">
                    <span className="text-xs text-foreground-500 font-medium mb-2 block">
                      {item.date}
                    </span>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-100 mb-1.5">
                      {item.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}